import React, { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
const PageLoader = () => {
    return <div className='loader-wrap'>
        <LinearProgress/>
    </div>
}
export default PageLoader